

import { motion } from "framer-motion";
import { fadeInUp } from "@/lib/motion";

interface SectionHeadingProps {
  overline?: string;
  title: string;
  subtitle?: string;
  centered?: boolean;
  light?: boolean;
}

export function SectionHeading({
  overline,
  title,
  subtitle,
  centered = true,
  light = false,
}: SectionHeadingProps) {
  return (
    <motion.div
      variants={fadeInUp}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, margin: "-50px" }}
      className={`max-w-3xl ${centered ? "mx-auto text-center" : ""} mb-16`}
    >
      {overline && (
        <p
          className={`text-xs uppercase tracking-[0.25em] font-semibold mb-3 ${
            light ? "text-warm-white/40" : "text-amber"
          }`}
        >
          {overline}
        </p>
      )}
      <h2
        className={`text-3xl md:text-4xl lg:text-5xl font-display font-semibold text-balance leading-tight ${
          light ? "text-warm-white" : "text-charcoal"
        }`}
      >
        {title}
      </h2>
      {subtitle && (
        <p
          className={`mt-5 text-base md:text-lg leading-relaxed max-w-2xl ${
            centered ? "mx-auto" : ""
          } ${light ? "text-warm-white/60" : "text-graphite-light"}`}
        >
          {subtitle}
        </p>
      )}
    </motion.div>
  );
}
